import { render, staticRenderFns } from "./GSchoolSetting.vue?vue&type=template&id=77b68494&scoped=true&"
import script from "./GSchoolSetting.vue?vue&type=script&lang=ts&"
export * from "./GSchoolSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolSetting.vue?vue&type=style&index=0&id=77b68494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b68494",
  null
  
)

export default component.exports